<script setup>
import {computed} from "vue";

const props = defineProps({
    blog: {
        type: Object,
        value: null
    },
})

const buttonStatus = computed(() => {
    return props.blog.read.length > 0 ? 'Close' : 'Confirm'
});

const emit = defineEmits(['confirm'])

function openAttachment(e) {
    e.preventDefault();
    if (props.blog.attachment) {
        window.open(props.blog.attachment, '_blank');
    }
}
function formatTime(datetime){
    return dayjs(datetime).format('YYYY-MM-DD')
}

function confirm(){
    const id  = props.blog.read.length ? null : props.blog?.id
    emit('confirm', id)
}



</script>


<template>
    <div class="bg-white px-2 pt-8 pb-4 overflow-y-auto  h-[90vh]" v-if="blog">
        <div class="text-lg text-indigo-400">{{ blog?.title }}</div>
        <div class="text-sm font-bold my-2">{{ formatTime(blog?.created_at) }}</div>
        <div class="my-2">
            <div v-html="blog?.content"></div>
            <div v-if="blog?.attachment" class="mt-2 flex items-center">
                <button
                    @click="openAttachment"
                    class="px-4 py-2 bg-indigo-400 text-white rounded hover:bg-indigo-700 cursor:pointer"
                >
                    Open Attachment
                </button>
            </div>
        </div>
        <hr class="mt-8">
        <div class="mt-4 flex justify-center">
            <button class="rounded px-4 py-2 bg-gray-700 text-white" @click="confirm">{{ buttonStatus  }}</button>
        </div>
    </div>
</template>
